export default "__VITE_ASSET__BmiFFsOd__"